import React, {useState,  useContext, useEffect} from 'react';
import styled from 'styled-components';
import {OverlayContext} from './../../../contexts/OverlayContext';

import {SILVERTREE, BITTERSWEET, BLACKPEARL, OzContainer, OzCard, OzButton, OzProjectTag} from "@ozwol/webui";

import ProjectsService from '../../../services/ProjectsService';

import {convertSize} from '../../../helpers';
import ErrorMessage from '../../../components/ErrorMessage';
import SuccessMessage from '../../../components/SuccessMessage';

const VALID_EXTS = [
	".bmp",
	".gif",
	".jpf",
	".jpeg",
	".jpg",
	".jps",
	".pbm",
	".pcx",
	".png",
	".psd",
	".pxr",
	".tga",
	".tif",
	".tiff",
	".webp"
];

const HFHeaderLeft = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 10px;

`;
const HFHeaderRight = styled.div`
	text-align: left;
	& div div:first-child{
		margin-right: 5px;
	}
	& div div div:first-child{
		display: none;
	}
`;
const HFIcon = styled.div`
	display: inline-block;
  width: 26px;
  height: 26px;
  margin-right: -3px;
  color: ${SILVERTREE};
  margin-bottom: -1px;
  flex-grow: 0;
  flex-shrink: 0;

  & span{
    // background: red;
    display: block;
  }

`;
const Content = styled.div`
    font-size: 12px;
		height: 50vh;
		overflow-x: hidden;
		overflow-y: auto;
`;


const Row = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
  border-bottom: 1px dashed #dedede;
	height: 36px;
`;

const Icon = styled.div`
  width: 26px;
  height: 26px;
  margin-right: 10px;
  color: ${props => props.isBroken ? BITTERSWEET : BLACKPEARL};
  margin-bottom: -1px;
  flex-grow: 0;
  flex-shrink: 0;

  & span{
    // background: red;
    display: block;
  }

`;
const Name = styled.div`
	flex-grow: 1;
	flex-shrink: 1;
	padding-top: 1px;
  color: ${props => props.isBroken ? BITTERSWEET : BLACKPEARL};
`;
const Size = styled.div`
	padding-top: 1px;
  color: ${props => props.isBroken ? BITTERSWEET : BLACKPEARL};
`;

const OverlayUpload = ({projectUuid, fullPath, files, fnUpload, fromDnD}) => {
	const {removeOverlay} = useContext(OverlayContext);
	const [project, setProject] = useState(null);

  useEffect(() => {
		ProjectsService.get(projectUuid).then((response) => {
			setProject(response);
		}).catch((error) => {
			// setFetchError(formatError(error));
		});
  }, [projectUuid]);

  return (
    <OzContainer size="big">
			<OzCard
				headerSeparator={true}
				headerLeft={
					<HFHeaderLeft>
						<HFIcon><span className="material-symbols-outlined">drive_folder_upload</span></HFIcon> {fullPath.replace(projectUuid+"/HOTFOLDERS/INPUT/","")}
					</HFHeaderLeft>
				}
				headerRight={
					project ? 
					<HFHeaderRight>
						<OzProjectTag 
							uuid={projectUuid} 
							color={project.color}
							direction="horizontal"
						/>
					</HFHeaderRight> : null
				}
				footerLeft={
					<OzButton 
						variant="chetwodeblue-o" 
						onClick={() => removeOverlay("overlayUpload")}
					>
						Back
					</OzButton>
				}
				footerRight={
					<OzButton 
						disabled={false && files.filter(item => VALID_EXTS.includes(item.path.slice(item.path.lastIndexOf('.')).toLowerCase())).length === 0} 
						variant="silvertree-o" 
						onClick={() => {
							removeOverlay("overlayUpload");
							setTimeout(() => {
								// fnUpload(files.filter(item => VALID_EXTS.includes(item.path.slice(item.path.lastIndexOf('.')).toLowerCase())));
								fnUpload(files);
							},500);
						}}
					>
						{/*Upload {files.length > 0 ? " ("+files.filter(item => VALID_EXTS.includes(item.path.slice(item.path.lastIndexOf('.')).toLowerCase())).length+")" : null}<br/>*/}
						Upload {files.length > 0 ? " ("+files.length+")" : null}<br/>
					</OzButton>
				}
			>
				{fromDnD && files.length === 100 ? 
					<>
						<ErrorMessage noMargin>
							<div style={{"fontSize": "15px", "paddingBottom": "10px"}}>
								<b>You performed a drag and drop of a folder containing more than 100 files.</b>
							</div>							
							Due to browser limitations and security reasons, not all files may be uploaded correctly — in this case, the system can process a maximum of 100 files.<br/>
							To work around this limitation, we recommend that you:
							<ul>
								<li>drag and drop the files directly without using a folder</li>
								<li>split the files into multiple folders (if you want to use drag and drop)</li>
								<li>use the "Upload folder" button to ensure a complete and unrestricted upload.</li>
							</ul>
							If you uploaded exactly 100 files, you can ignore this message and continue.
						</ErrorMessage>
						<br/>
					</>
				: 
					<>
						<SuccessMessage noMargin>
							{/*<b>{files.filter(item => VALID_EXTS.includes(item.path.slice(item.path.lastIndexOf('.')).toLowerCase())).length}</b> files to upload.<br/>
							{files.filter(item => !VALID_EXTS.includes(item.path.slice(item.path.lastIndexOf('.')).toLowerCase())).length > 0 ? <span style={{"color": BITTERSWEET}}><b>{files.filter(item => !VALID_EXTS.includes(item.path.slice(item.path.lastIndexOf('.')).toLowerCase())).length}</b> will not be uploaded.</span> : ""}*/}
							<b>{files.length}</b> files to upload.
						</SuccessMessage>
						<br/>
					</>
				}
				<Content>
					{files.sort((a,b) => 
						VALID_EXTS.includes(a.path.slice(a.path.lastIndexOf('.')).toLowerCase()) - 
						VALID_EXTS.includes(b.path.slice(b.path.lastIndexOf('.')).toLowerCase())
					).map((item, i) => 
						<Row key={i}>
							<Icon 
								isBroken={false && !VALID_EXTS.includes(item.path.slice(item.path.lastIndexOf('.')).toLowerCase())}
							><span className="material-symbols-outlined">
								{false ?
									"broken_image"
								:
									"image"
								}
							</span></Icon>
							<Name isBroken={false && !VALID_EXTS.includes(item.path.slice(item.path.lastIndexOf('.')).toLowerCase())}>{item.path + (false && !VALID_EXTS.includes(item.path.slice(item.path.lastIndexOf('.')).toLowerCase()) ? " (file not supported)":"")}</Name>
							<Size isBroken={false && !VALID_EXTS.includes(item.path.slice(item.path.lastIndexOf('.')).toLowerCase())}>{convertSize(item.size)}</Size>
						</Row>
					)}
				</Content>
			</OzCard>
		</OzContainer>
  )
}

export default OverlayUpload;
